export default {"src":"/_next/static/image/public/images/ic_call_green_bg_white.baa80b025b696e7001d925e877213863.svg","height":30,"width":31};